import { useMemo } from "react";
import type { ReactNode } from "react";
import { IntlProvider as ReactIntlProvider } from "react-intl";
import { sharedEnvironment } from "@akina/config";
import { loggerService } from "@akina/infra";
import { flattenMessages, LocaleBootstrapper, useLocaleCopyStore, useLocaleStore } from "@akina/presentation";

type IntlProviderProps = Readonly<{
  children: ReactNode;
}>;

export function IntlProvider({ children }: IntlProviderProps) {
  const locale = useLocaleStore(state => state.locale);
  const localeCopy = useLocaleCopyStore(state => state.localeCopy);
  const messages = useMemo(() => flattenMessages(localeCopy), [localeCopy]);

  return (
    <ReactIntlProvider onError={handleIntlError} locale={locale} messages={messages}>
      <LocaleBootstrapper slugPrefixes={["shared", "webshop"]} />
      {children}
    </ReactIntlProvider>
  );
}

function handleIntlError(err: { code: string; message: string }) {
  if (err.code === "MISSING_TRANSLATION" || err.code === "MISSING_DATA") return;
  if (sharedEnvironment.environment !== "prod") {
    loggerService.warn("[IntlProvider]", err.message);
  }
}
